<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="webhooks-page-container">
  <div class="webhooks-content-wrapper">
    <div class="webhooks-table-container">
      <div class="px-4 py-4 border-b border-gray-200 flex items-center gap-4 relative">
        <div class="search-container-fixed flex-1 flex items-center justify-center gap-3">
          <div class="relative w-full max-w-xs">
            <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm pointer-events-none">search</span>
            <input
              type="text"
              class="search-input-webhooks w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:border-blue-500 focus:outline-none"
              [(ngModel)]="searchTerm"
              (input)="applyFilter()"
              placeholder="Rechercher par nom ou URL..."
            />
          </div>
          <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
            {{ filtered.length }} webhook{{ filtered.length > 1 ? 's' : '' }}
          </span>
        </div>
        
        <button 
          class="add-webhook-button bg-white hover:bg-blue-50 text-blue-900 rounded-full px-3 py-2 flex items-center justify-center transition-all duration-200 shadow-sm hover:shadow-md font-medium text-sm overflow-hidden"
          (click)="openAddModal()"
          title="Ajouter un webhook">
          <span class="material-symbols-outlined text-lg transition-transform duration-200 flex-shrink-0">add</span>
          <span class="add-webhook-button-text text-sm font-medium whitespace-nowrap">Ajouter un webhook</span>
        </button>
      </div>

      <div class="w-full">
        <table class="webhooks-table w-full">
          <thead class="webhooks-table-header">
            <tr>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors w-[12%] text-center" (click)="toggleSort('nom')">
                <div class="flex items-center justify-center gap-2">
                  <span>Nom</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'nom' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'nom'">↕</span>
                    <span *ngIf="sortField === 'nom' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'nom' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
              <th class="cursor-pointer hover:bg-gray-50 transition-colors w-[28%] text-center" (click)="toggleSort('webhookUrlReceipt')">
                <div class="flex items-center justify-center gap-2">
                  <span>URL Webhook</span>
                  <span class="sort-icon text-xs" [ngClass]="sortField === 'webhookUrlReceipt' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                    <span *ngIf="sortField !== 'webhookUrlReceipt'">↕</span>
                    <span *ngIf="sortField === 'webhookUrlReceipt' && sortDirection === 'asc'">↓</span>
                    <span *ngIf="sortField === 'webhookUrlReceipt' && sortDirection === 'desc'">↑</span>
                  </span>
                </div>
              </th>
              <th class="w-[45%] text-center">JSON</th>
              <th class="w-[15%] text-center">Actions</th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr *ngFor="let webhook of filtered" class="webhooks-table-row">
              <td class="webhooks-table-cell font-medium text-gray-800 text-center">
                {{ webhook.nom }}
              </td>
              <td class="webhooks-table-cell webhooks-table-cell-url">
                <div class="flex items-center gap-2 justify-center">
                  <span class="text-sm text-gray-700 break-all flex-1 min-w-0">{{ webhook.webhookUrlReceipt }}</span>
                  <button 
                    class="webhook-copy-btn" 
                    type="button" 
                    (click)="copyWebhook(webhook.webhookUrlReceipt)"
                    title="Copier l'URL webhook">
                    <span class="material-symbols-outlined text-sm">content_copy</span>
                  </button>
                </div>
              </td>
              <td class="webhooks-table-cell">
                <div class="flex items-center justify-center">
                  <pre class="text-xs text-gray-600 font-mono bg-gray-50 p-2 rounded border border-gray-200 max-w-full overflow-x-auto whitespace-pre-wrap break-words">{{ formatJsonData(webhook.responseJsonData) }}</pre>
                </div>
              </td>
              <td class="webhooks-table-cell text-center">
                <div class="actions-row-modern">
                  <button 
                    type="button" 
                    class="btn-action-modern btn-edit" 
                    (click)="openEditModal(webhook)"
                    title="Modifier">
                    <span class="material-symbols-outlined">edit</span>
                  </button>
                  <button 
                    type="button" 
                    class="btn-action-modern btn-delete" 
                    (click)="deleteWebhook(webhook)"
                    title="Supprimer">
                    <span class="material-symbols-outlined">delete</span>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="filtered.length === 0" class="webhooks-table-row">
              <td colspan="4" class="webhooks-table-cell text-center text-gray-500 py-8">
                Aucun webhook configuré
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="webhooks-modal-overlay" *ngIf="showAddModal">
  <div class="webhooks-modal-content" #addModalContent>
    <div class="webhooks-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">add</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Ajouter un webhook</h2>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeModals()" 
        type="button"
        [disabled]="isLoading">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="webhooks-modal-body">
      <form (ngSubmit)="addWebhook(); $event.preventDefault()" id="addForm">
        <div class="space-y-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Nom
              <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="formNom"
              name="nom"
              placeholder="Nom du webhook"
              class="webhooks-form-input"
              required />
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              URL Webhook
              <span class="text-red-500">*</span>
            </label>
            <input
              type="url"
              [(ngModel)]="formWebhookUrlReceipt"
              name="webhookUrlReceipt"
              placeholder="https://example.com/webhook"
              class="webhooks-form-input"
              required />
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Format du numéro
            </label>
            <select
              [(ngModel)]="formPhoneNumberFormat"
              name="phoneNumberFormat"
              class="webhooks-form-input">
              <option value="0">0 (ex: 0612345678)</option>
              <option value="33">33 (ex: 33612345678)</option>
              <option value="+33">+33 (ex: +33612345678)</option>
            </select>
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Token
            </label>
            <input
              type="text"
              [(ngModel)]="formToken"
              name="token"
              placeholder="Token d'authentification (optionnel)"
              class="webhooks-form-input" />
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              JSON de réponse
            </label>
            <textarea
              [(ngModel)]="formResponseJsonData"
              name="responseJsonData"
              placeholder='{"key": "value"}'
              class="webhooks-form-input min-h-[120px] font-mono text-sm"
              rows="6"></textarea>
            <p class="text-xs text-gray-500">Format JSON valide requis</p>
          </div>
        </div>
      </form>
    </div>
    
    <div class="webhooks-modal-footer">
      <button 
        type="button" 
        class="webhooks-btn-secondary"
        (click)="closeModals()"
        [disabled]="isLoading">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="webhooks-btn-primary"
        form="addForm"
        [disabled]="isLoading">
        <span *ngIf="!isLoading" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">add</span>
          <span>Ajouter</span>
        </span>
        <span *ngIf="isLoading" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Ajout...</span>
        </span>
      </button>
    </div>
  </div>
</div>

<div class="webhooks-modal-overlay" *ngIf="showEditModal">
  <div class="webhooks-modal-content" #editModalContent>
    <div class="webhooks-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">edit</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Modifier le webhook</h2>
      </div>
      <button 
        class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
        (click)="closeModals()" 
        type="button"
        [disabled]="isLoading">
        <span class="material-symbols-outlined text-lg">close</span>
      </button>
    </div>
    
    <div class="webhooks-modal-body">
      <form (ngSubmit)="updateWebhook(); $event.preventDefault()" id="editForm">
        <div class="space-y-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Nom
              <span class="text-red-500">*</span>
            </label>
            <input
              type="text"
              [(ngModel)]="formNom"
              name="nom"
              placeholder="Nom du webhook"
              class="webhooks-form-input"
              required />
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              URL Webhook
              <span class="text-red-500">*</span>
            </label>
            <input
              type="url"
              [(ngModel)]="formWebhookUrlReceipt"
              name="webhookUrlReceipt"
              placeholder="https://example.com/webhook"
              class="webhooks-form-input"
              required />
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Format du numéro
            </label>
            <select
              [(ngModel)]="formPhoneNumberFormat"
              name="phoneNumberFormat"
              class="webhooks-form-input">
              <option value="0">0 (ex: 0612345678)</option>
              <option value="33">33 (ex: 33612345678)</option>
              <option value="+33">+33 (ex: +33612345678)</option>
            </select>
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              Token
            </label>
            <input
              type="text"
              [(ngModel)]="formToken"
              name="token"
              placeholder="Token d'authentification (optionnel)"
              class="webhooks-form-input" />
          </div>
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
              JSON de réponse
            </label>
            <textarea
              [(ngModel)]="formResponseJsonData"
              name="responseJsonData"
              placeholder='{"key": "value"}'
              class="webhooks-form-input min-h-[120px] font-mono text-sm"
              rows="6"></textarea>
            <p class="text-xs text-gray-500">Format JSON valide requis</p>
          </div>
        </div>
      </form>
    </div>
    
    <div class="webhooks-modal-footer">
      <button 
        type="button" 
        class="webhooks-btn-secondary"
        (click)="closeModals()"
        [disabled]="isLoading">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="webhooks-btn-primary"
        form="editForm"
        [disabled]="isLoading">
        <span *ngIf="!isLoading" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">save</span>
          <span>Enregistrer</span>
        </span>
        <span *ngIf="isLoading" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Enregistrement...</span>
        </span>
      </button>
    </div>
  </div>
</div>

